/* eslint-disable max-len */
/* eslint-disable react/display-name */
import { memo, useMemo } from 'react'

type CrossMarkerProps = {
  x: number
  y: number
}

export const CrossMarker = memo(({ x, y }: CrossMarkerProps) => {
  const crossStyles = useMemo(
    () => ({
      position: 'absolute' as const,
      height: '56px',
      width: '56px',
      top: `calc(${y}% - 28px)`,
      left: `calc(${x}% - 28px)`,
      cursor: 'none',
      backgroundColor: 'unset',
      background: 'unset',
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    [x, y],
  )

  return (
    <div style={crossStyles}>
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.05752 7.05721C7.57822 6.53651 8.42244 6.53651 8.94313 7.05721L16.0003 14.1144L23.0575 7.05721C23.5782 6.53651 24.4224 6.53651 24.9431 7.05721C25.4638 7.57791 25.4638 8.42213 24.9431 8.94283L17.8859 16L24.9431 23.0572C25.4638 23.5779 25.4638 24.4221 24.9431 24.9428C24.4224 25.4635 23.5782 25.4635 23.0575 24.9428L16.0003 17.8856L8.94313 24.9428C8.42244 25.4635 7.57822 25.4635 7.05752 24.9428C6.53682 24.4221 6.53682 23.5779 7.05752 23.0572L14.1147 16L7.05752 8.94283C6.53682 8.42213 6.53682 7.57791 7.05752 7.05721Z"
          fill="#6A3FE4"
        />
      </svg>
    </div>
  )
})
